export default __webpack_public_path__ + "static/media/success-registration.e7db5966.svg";